import { useAuthStore } from '@/store/authStore';
import SupervisorDashboard from './SupervisorDashboard';
import SafetyManagerDashboard from './SafetyManagerDashboard';
import ExecutiveDashboard from './ExecutiveDashboard';
import SSRDashboard from './SSRDashboard';

export default function DashboardPage() {
  const userRole = useAuthStore((s) => s.userRole);

  return (
    <div className="space-y-6">
      <h1 className="text-lg font-semibold">Dashboard</h1>

      {userRole === 'ssr' ? (
        <SSRDashboard />
      ) : userRole === 'safety_manager' || userRole === 'tenant_admin' ? (
        <SafetyManagerDashboard />
      ) : userRole === 'executive' ? (
        <ExecutiveDashboard />
      ) : (
        <SupervisorDashboard />
      )}
    </div>
  );
}
